import type { SanityCaseStudy } from '#/lib/sanity/queries/blogPost';
import { cn } from '#/lib/utils';
import { Image } from '#/components/Image';

type CaseStudiesQuoteProps = NonNullable<SanityCaseStudy['testimonial']>;
export function CaseStudiesQuote(props: CaseStudiesQuoteProps) {
  const headshot = props.headshot;
  return (
    <div className="flex lg:flex-row flex-col-reverse items-stretch rounded-32 border-charcoal overflow-hidden lg:border max-w-600 lg:max-w-none mx-auto lg:mb-90">
      {headshot ? (
        <div
          className={cn(
            'flex-shrink-0 aspect-square lg:aspect-[5/7] lg:w-[26%] translate-y-[-56px] lg:translate-y-0 transition-opacity duration-500 delay-500',
            headshot && 'translate-y-[-56px] lg:translate-y-0',
          )}
        >
          <Image
            image={headshot}
            sizes="400px"
            aspect={false}
            className="h-full w-full rounded-32 lg:rounded-none lg:rounded-r-32 border-charcoal border lg:border-t-0 lg:border-b-0 lg:border-l-0"
            mediaClassName="block object-cover object-center"
          />
        </div>
      ) : null}
      <div
        className={cn(
          'p-24 l:p-40 flex justify-center flex-col rounded-32 border border-charcoal lg:border-none lg:rounded-none l:pb-40',
          headshot ? 'border-b-0 pb-80' : 'mb-40 l:mb-0',
        )}
      >
        <h2 className="font-[440] leading-125 m:leading-136 -tracking-2 m:-tracking-3 m:text-34 text-22 mb-20">
          “{props.quote}”
        </h2>
        <p className="text-18 leading-116 font-[440] m:text-24">{props.name}</p>
        <p className="text-14 leading-116 font-light m:text-20">
          {props.caption}
        </p>
      </div>
    </div>
  );
}
